import React from 'react';
import './Footer.css';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

function Footer() {
  const phoneNumber = '919385331477';
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="Footer">
      <p><strong>{t.siteName}</strong></p>
      <p>{t.footerAddress}</p>
      <p>{t.footerPhone}: +91 93853 31477 | {t.footerEmail}: info@ayushmancure.com</p>
      <div className="contact-links">
        <a href={`sms:${phoneNumber}`} target="_blank" rel="noopener noreferrer">{t.sendSMS}</a>
        <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer">{t.whatsappUs}</a>
      </div>
    </footer>
  );
}

export default Footer;

